export enum AddressAttachableEntityType {
  DEAL = 'deal',
}

export type LoqateAddressResult = {
  id: string;
  label: string;
  type?: 'Postcode' | 'Address' | 'BuildingName';
};

export enum LoqateAddressResultType {
  POSTCODE = 'Postcode',
  ADDRESS = 'Address',
  BUILDING_NAME = 'BuildingName',
}

/**
 * The structured address returned by the `/api/addresses/retrieve` lookup once
 * a specific address has been selected.
 */
export type RetrievedAddress = {
  line1: string;
  line2: string | null;
  city: string | null;
  administrativeArea: string | null;
  postcode: string | null;
  country: string | null;
};
